define('formkit/view/form.object/rule/condition.collection.view',['require','exports','module','uikit/uikit','../../../model/condition.model','./condition.item.view'],function(require, exports, module) {
  var UIKit             = require('uikit/uikit');
  var ConditionModel    = require('../../../model/condition.model');
  var ConditionItemView = require('./condition.item.view');

  var ConditionCollectionView = UIKit.CollectionView.extend({
    className: 'ui attached segment',

    childView: ConditionItemView,

    childViewOptions: function () {
      return {
        form: this.getOption('form')
      }
    },

    onChildviewAddCondition: function () {
      this.addCondition();
    },

    onChildviewRemoveCondition: function (conditionView, conditionModel) {
      this.removeCondition(conditionModel);
    },

    addCondition: function() {
      this.collection.add({});
    },

    removeCondition: function(conditionModel) {
      this.collection.remove(conditionModel);
    }
  });

  module.exports = ConditionCollectionView;
});

